export default "__VITE_ASSET__BOpBVqX0__"